module.exports = __webpack_public_path__ + "static/media/itunes-note.da131685.svg";